var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-modal__inner"},[_c('div',{staticClass:"c-modal__header"},[_c('ModalCloseButton',{on:{"click":_vm.closeModal}}),(_vm.$slots.header)?_c('span',{staticClass:"c-modal__title"},[_vm._t("header")],2):_vm._e()],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }